import SchoolGroupResidentialType from './SchoolGroupResidentialType.page';

export default SchoolGroupResidentialType;